export const RoutePaths = {
  HOME: "/",
  REGISTER: "/register",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",


  STUDENT_DASHBOARD_PAGE: "/portal/dashboard",
  STUDENT_CLASS_DETAILS_PAGE: "/portal/classDetails",
  STUDENT_ENROLLED_CLASSES_PAGE: "/portal/enrolledClasses",
  STUDENT_CLASS_MONTH_DETAILS_PAGE: "/portal/classMonthDetails",
  STUDENT_CLASS_MONTH_PAYMENT_PAGE: "/portal/classMonthPayment",
  STUDENT_CLASS_SCHEDULE_DETAILS_PAGE: "/portal/classScheduleDetails",
  STUDENT_PROFILE_PAGE: "/portal/profile",
  STUDENT_PAYMENT_HISTORY_PAGE: "/portal/paymentHistory",
  STUDENT_ONLINE_PAYMENT_RESULT_PAGE: "/portal/onlinePaymentResult",
  STUDENT_STUDY_PACKS_PAGE: "/portal/studyPacks",
  STUDENT_PAST_PAPERS_PAGE: "/portal/pastPapers",
  STUDENT_FREE_CLASSES_PAGE: "/portal/freeClasses",
  STUDENT_PAST_PAPER_DETAILS_PAGE: "/portal/pastPaperDetails",
  STUDENT_SEMINARS_PAGE: "/portal/seminars",
  STUDENT_SEMINAR_DETAILS_PAGE: "/portal/seminarDetails",
  STUDENT_SEMINAR_PAYMENT_PAGE: "/portal/seminarPayment",
  STUDENT_COURSES_PAGE: "/portal/courses",
  STUDENT_COURSE_DETAILS_PAGE: "/portal/courseDetails",
  STUDENT_COURSE_PAYMENT_PAGE: "/portal/coursePayment",


  ADMIN_DASHBOARD_PAGE: "/portal/admin/dashboard",
  ADMIN_CLASS_PAGE: "/portal/admin/classes",
  ADMIN_CLASS_SCHEDULE_PAGE: "/portal/admin/classSchedule",
  ADMIN_BANK_TRANSFER_MANAGE_PAGE: "/portal/admin/bankTransfersManage",
  ADMIN_STUDENT_MANAGE_PAGE: "/portal/admin/students",
  ADMIN_STUDENT_DETAILS_PAGE: "/portal/admin/studentDetails",
  ADMIN_STAFF_MANAGE_PAGE: "/portal/admin/staffManage",
  ADMIN_BANNER_MANAGE_PAGE: "/portal/admin/bannerManage",
  ADMIN_SCHEDULE_DOCUMENT_MANAGE_PAGE: "/portal/admin/scheduleDocumentManage",
  ADMIN_MANAGE_PAST_PAPERS_PAGE: "/portal/admin/managePastPapers",
  ADMIN_MANAGE_PAST_PAPER_FILES_PAGE: "/portal/admin/managePastPaperFiles",
  ADMIN_MANAGE_SEMINARS_PAGE: "/portal/admin/manageSeminars",
  ADMIN_MANAGE_SEMINAR_FILES_PAGE: "/portal/admin/manageSeminarFiles",
  ADMIN_MANAGE_SEMINAR_STUDENTS_PAGE: "/portal/admin/manageSeminarStudents",
  ADMIN_MANAGE_COURSES_PAGE: "/portal/admin/manageCourses",
  ADMIN_MANAGE_COURSE_FILES_PAGE: "/portal/admin/manageCourseFiles",
  ADMIN_MANAGE_COURSE_STUDENTS_PAGE: "/portal/admin/manageCourseStudents",
};
